export const HOME_PATH = '/';
export const ACCOUNTS_PATH = '/accounts';
export const GROUPS_PATH = '/groups';
export const JOURNALS_PATH = '/journals';
export const GROUPS_ACCOUNTS_PATH = '/groupsaccounts';
export const KPIS_PATH = '/kpis';
export const SETTINGS_PATH = '/settings';
